import React, { useEffect, useState } from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { collection, getDocs, deleteDoc, doc } from 'firebase/firestore';
import { getAuth } from 'firebase/auth'; // Import Firebase auth
import { db } from '../../config/firebase';
import { Box, Button, Typography } from '@mui/material';
import ClassNavbar from './ClassNavbar'; // Import ClassNavbar

const People = () => {
  const [people, setPeople] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userEmail, setUserEmail] = useState(''); // Store current user email

  const auth = getAuth(); // Initialize Firebase auth

  const fetchJoinedClasses = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'joinedClasses'));
      const data = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setPeople(data);
    } catch (error) {
      console.error('Error fetching joined classes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await deleteDoc(doc(db, 'joinedClasses', id));
      setPeople((prev) => prev.filter((person) => person.id !== id));
    } catch (error) {
      console.error('Error deleting entry:', error);
    }
  };

  useEffect(() => {
    fetchJoinedClasses();

    // Get the currently signed-in user's email
    const currentUser = auth.currentUser;
    if (currentUser) {
      setUserEmail(currentUser.email);
    }
  }, []);

  const columns = [
    { field: 'userName', headerName: 'Name', flex: 1 },
    { field: 'userEmail', headerName: 'Email', flex: 1 },
    { field: 'className', headerName: 'Class', flex: 1 },
    {
      field: 'action',
      headerName: 'Action',
      renderCell: (params) => {
        // Conditionally render the delete button based on user email
        if (userEmail === 'ed@gmail.com' || userEmail === '91xfdc@gmail.com') {
          return (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => handleDelete(params.row.id)}
              sx={{ textTransform: 'capitalize' }}
            >
              Delete
            </Button>
          );
        }
        return null; // No delete button for other users
      },
      flex: 0.5,
    },
  ];

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      <ClassNavbar /> {/* Add ClassNavbar */}

      <Box
        sx={{
          margin: '40px auto',
          width: '80%',
          maxWidth: 900,
          padding: 3,
          bgcolor: 'white',
          borderRadius: 2,
          boxShadow: 3,
        }}
      >
        <Typography variant="h4" sx={{ mb: 3, textAlign: 'center' }}>
          People Joined Classes
        </Typography>

        {loading ? (
          <Typography variant="h6" sx={{ textAlign: 'center' }}>
            Loading...
          </Typography>
        ) : people.length === 0 ? (
          <Typography variant="h6" sx={{ textAlign: 'center', color: 'gray' }}>
            No people have joined any classes yet.
          </Typography>
        ) : (
          <DataGrid
            rows={people}
            columns={columns}
            pageSize={5}
            rowsPerPageOptions={[5]}
            checkboxSelection
            sx={{
              height: 400,
              '& .MuiDataGrid-root': {
                borderRadius: 2,
                borderColor: 'divider',
              },
              '& .MuiDataGrid-cell': {
                fontSize: '1rem',
              },
              '& .MuiDataGrid-columnHeaders': {
                bgcolor: 'primary.main',
                color: 'white',
              },
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default People;
